module.exports = __webpack_public_path__ + "static/media/landing-4.1d3baada.svg";